import CustomContainer from "../../components/common/CustomContainer"
import styles from "../../assets/styles/dashboard.module.css"
import { FormGroup, FormLabel } from "@mui/material"
import { lazy, useEffect, useState } from "react"
import { getHealthRiskApi } from "../../utils/api/services"
import { useSelector } from "react-redux"
import { RootState } from "../../utils/store"
import { toast } from "react-toastify"
import { DatePicker } from "@mui/x-date-pickers"
import moment from "moment"
const CustomPieChart = lazy(() => import("../../components/common/CustomPieChart"))

type Items = { status: string; count: number }
type Status = "low" | "medium" | "high" | "critical";
const HealthRisk = () => {
    const [filterData, setFilterData] = useState<filterTypes>({
        from_date: '',
        to_date: ''
    })
    const [cardioData, setCardioData] = useState<PieDataTypes[] | []>([])
    const [HypertensionData, setHypertensionData] = useState<PieDataTypes[] | []>([])
    const [daibeticsData, setDaibeticsData] = useState<PieDataTypes[] | []>([])
    const { LoginData } = useSelector((state: RootState) => state.auth)


    const handleDateFilters: HandleDateChangeType = (date, name) => {
        const formattedDate = moment(date).format('YYYY-MM-DD');
        if (!date) {
            setFilterData({ ...filterData, [name]: '' });
        }
        else {
            setFilterData({ ...filterData, [name]: formattedDate });
        }
    };

    const fetchHealthRisk = async (data: { companyId: number, from_date?: string, to_date?: string }) => {
        try {
            const result = await getHealthRiskApi(data);
            if (result?.success) {
                const statusColorMapping: Record<Status, string> = {
                    "low": "#54a276",
                    "medium": "#ffcd29",
                    "high": "#aa2626",
                    "critical": "#aa2626",
                };
                const _cardio = result?.data?.cardioResult?.map((item: Items) => {
                    return {
                        name: item?.status,
                        value: item?.count,
                        color: statusColorMapping[item.status?.toLowerCase() as Status] || "#0562cc"
                    }
                })
                const _hyperData = result?.data?.hyperResult?.map((item: Items) => {
                    return {
                        name: item?.status,
                        value: item?.count,
                        color: statusColorMapping[item.status?.toLowerCase() as Status] || "#0562cc"
                    }
                })
                const _DaibeticsData = result?.data?.daibeticsResult?.map((item: Items) => {
                    return {
                        name: item?.status,
                        value: item?.count,
                        color: statusColorMapping[item.status?.toLowerCase() as Status] || "#0562cc"
                    }
                })
                setCardioData(_cardio)
                setHypertensionData(_hyperData);
                setDaibeticsData(_DaibeticsData);
            }
        } catch (error: any) {
            toast.error(error?.data?.errors || error?.message);
        }
    }

    useEffect(() => {
        if (LoginData) {
            fetchHealthRisk({ companyId: LoginData?.companyId, from_date: filterData?.from_date, to_date: filterData?.to_date })
        }
    }, [filterData])
    return (
        <CustomContainer>
            <div className={'AllPageMain'}>
                <div className={'HeadAndButton'}>
                    <h2>Manage Employees</h2>
                </div>
                <div className="flex justify-end items-center gap-6">
                    <FormGroup className="customFormGroup">
                        <FormLabel className="customFormLabel">From Date</FormLabel>
                        <DatePicker
                            className="custumTextField profileInput"
                            value={filterData?.from_date ? moment(filterData?.from_date, 'YYYY-MM-DD') : null}
                            maxDate={moment(new Date(), 'YYYY-MM-DD')}
                            format="YYYY-MM-DD"
                            onChange={(date) => handleDateFilters(date ? moment(date)?.toDate(): null, 'from_date')}
                            slotProps={{ field: { clearable: filterData?.from_date ? true : false } }}
                        />
                    </FormGroup>
                    <FormGroup className="customFormGroup">
                        <FormLabel className="customFormLabel">To Date</FormLabel>
                        <DatePicker
                            className="custumTextField profileInput"
                            value={filterData?.to_date ? moment(filterData?.to_date, 'YYYY-MM-DD') : null}
                            maxDate={moment(new Date(), 'YYYY-MM-DD')}
                            minDate={moment(filterData?.from_date, 'YYYY-MM-DD')}
                            disabled={filterData?.from_date === "" ? true : false}
                            format="YYYY-MM-DD"
                            onChange={(date) => handleDateFilters(date ? moment(date)?.toDate() : null, 'to_date')}
                            slotProps={{ field: { clearable: filterData?.from_date ? true : false } }}
                        />
                    </FormGroup>
                </div>
                <div className={`${styles.appointmentsMain} mt-8`}>
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 p-6">
                        <CustomPieChart chartData={cardioData} title="Cardio Vascular" />
                        <CustomPieChart chartData={HypertensionData} title="Hypertension" />
                        <CustomPieChart chartData={daibeticsData} title="Diabetes" />
                    </div>
                </div>
            </div>
        </CustomContainer>
    )
}

export default HealthRisk